// Function useful for filtering arrays to non nullable values while keeping TS happy
// Alternative to .filter(Boolean) which causes TS complaints
export function nonNullable(value) {
    return value !== null && value !== undefined;
}
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "asc";
    SortOrder["Desc"] = "desc";
})(SortOrder || (SortOrder = {}));
export var MagnitudeShorthand;
(function (MagnitudeShorthand) {
    MagnitudeShorthand["Thousand"] = "k";
    MagnitudeShorthand["Million"] = "m";
    MagnitudeShorthand["Billion"] = "bn";
    MagnitudeShorthand["Trillion"] = "tn";
})(MagnitudeShorthand || (MagnitudeShorthand = {}));
//# sourceMappingURL=index.js.map